const columnServiceName = "/Column";

export function columnService (http)  {
    return {
        getAllColumnsAsync: async () => {
            return await http.get(columnServiceName + '/GetAllColumnsAsync');
        },         
    }
}